function IconTwitter() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="1024"
      height="1024"
      viewBox="0 0 1024 1024"
    >
      <g id="icomoon-ignore" />
      <path
        fill="currentColor"
        d="M369.216 832c289.6 0 448.32-246.080 448.32-459.84 0-6.72-0.32-13.76-0.64-20.8 31.021-23.165 57.149-50.824 77.968-82.304l0.752-1.215c-26.362 12.29-56.954 21.195-89.075 25.131l-1.485 0.148c32.838-20.37 57.421-51.385 69.13-88.142l0.31-1.138c-28.781 17.879-62.349 31.433-98.195 38.708l-1.965 0.332c-28.528-31.246-69.411-50.799-114.864-50.88h-0.016c-87.37 1.114-157.77 72.201-157.77 159.731 0 0.656 0.006 1.315 0.013 1.968v-0.099c0.090 13.088 1.6 25.773 4.387 37.978l-0.227-1.178c-132.016-7.382-247.723-71.439-324.089-168.029l-0.71-0.931c-13.418 23.385-21.361 51.396-21.44 81.256v0.024c-0.001 0.24-0.002 0.524-0.002 0.809 0 55.163 27.508 103.899 69.554 133.243l0.528 0.349c-26.374-0.8-50.86-8.182-72.085-20.55l0.725 0.39v2.24c-0.003 0.323-0.004 0.707-0.004 1.091 0 76.675 53.57 140.838 125.325 157.104l1.079 0.205c-12.354 3.456-26.54 5.44-41.19 5.44-0.031 0-0.064 0-0.095 0h0.005c-0.11 0-0.239 0-0.369 0-10.4 0-20.555-1.050-30.365-3.046l0.974 0.166c19.866 64.234 77.894 110.432 146.986 112.314l0.214 0.006c-53.068 43.014-121.407 69.075-195.83 69.12h-0.010c-0.358 0-0.781 0-1.204 0-12.772 0-25.355-0.813-37.699-2.394l1.461 0.154c68.001 45.466 151.629 72.579 241.586 72.64h0.013z"
      />
    </svg>
  );
}

export { IconTwitter };
